import React, { useEffect, useState } from 'react';
import axios from 'axios';

function Offers() {
    const [offers, setOffers] = useState([]);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const [formData, setFormData] = useState({
        offer_number: '',
        reference_number: '',
        document_type: 'A',
        service_type_code: '',
        service_type_label: '',
        property_type_code: '',
        property_type_label: '',
        year_short: '',
        object_number: '',
        try_number: '',
        customer_name: '',
        object_id: 0,
        amount_net: '',
        vat_rate: '',
        amount_gross: '',
        status: '',
        issue_date: '',
        valid_until: ''
    });

    const loadOffers = async () => {
        try {
            const response = await axios.get('/api/offers');
            setOffers(Array.isArray(response.data) ? response.data : []);
        } catch (err) {
            setOffers([]);
            setError('Angebote konnten nicht geladen werden.');
        }
    };

    useEffect(() => {
        loadOffers();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleNumberPreview = async () => {
        setMessage('');
        setError('');

        try {
            const response = await axios.get('/api/offer-number-preview', {
                params: {
                    document_type: formData.document_type || 'A',
                    service_type_code: formData.service_type_code || 'P',
                    property_type_code: formData.property_type_code || '1',
                    object_number: formData.object_number || '1'
                }
            });

            setFormData((prev) => ({
                ...prev,
                offer_number: response.data.offer_number || ''
            }));
            setMessage('Angebotsnummer erfolgreich vorgeschlagen.');
        } catch (err) {
            setError('Nummernvorschau für Angebot fehlgeschlagen.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        try {
            const response = await axios.post('/api/offers', {
                ...formData,
                object_number: Number(formData.object_number),
                try_number: Number(formData.try_number),
                object_id: Number(formData.object_id),
                amount_net: Number(formData.amount_net),
                vat_rate: Number(formData.vat_rate),
                amount_gross: Number(formData.amount_gross)
            });

            if (response.status === 200 || response.status === 201) {
                setMessage('Angebot erfolgreich erstellt.');
                await loadOffers();
            }
        } catch (err) {
            setError('Angebot konnte nicht gespeichert werden.');
        }
    };

    return (
        <div>
            <h1>Angebote</h1>

            {message && <p>{message}</p>}
            {error && <p className="error">{error}</p>}

            <button type="button" onClick={handleNumberPreview}>
                Nummernvorschau
            </button>

            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="offer_number"
                    placeholder="Angebotsnummer"
                    value={formData.offer_number}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="reference_number"
                    placeholder="Referenznummer"
                    value={formData.reference_number}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="document_type"
                    value={formData.document_type}
                    onChange={handleChange}
                    readOnly
                />

                <input
                    type="text"
                    name="service_type_code"
                    placeholder="Leistungsart-Code"
                    value={formData.service_type_code}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="service_type_label"
                    placeholder="Leistungsart"
                    value={formData.service_type_label}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="property_type_code"
                    placeholder="Objektart-Code"
                    value={formData.property_type_code}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="property_type_label"
                    placeholder="Objektart"
                    value={formData.property_type_label}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="year_short"
                    placeholder="Jahr"
                    value={formData.year_short}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="object_number"
                    placeholder="Objektnummer"
                    value={formData.object_number}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="try_number"
                    placeholder="Versuch"
                    value={formData.try_number}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="customer_name"
                    placeholder="Kundenname"
                    value={formData.customer_name}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="object_id"
                    placeholder="Objekt-ID"
                    value={formData.object_id}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="amount_net"
                    placeholder="Betrag netto"
                    value={formData.amount_net}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="vat_rate"
                    placeholder="USt-Satz"
                    value={formData.vat_rate}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="amount_gross"
                    placeholder="Betrag brutto"
                    value={formData.amount_gross}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="status"
                    placeholder="Status"
                    value={formData.status}
                    onChange={handleChange}
                    required
                />

                <input
                    type="date"
                    name="issue_date"
                    value={formData.issue_date}
                    onChange={handleChange}
                    required
                />

                <input
                    type="date"
                    name="valid_until"
                    value={formData.valid_until}
                    onChange={handleChange}
                    required
                />

                <button type="submit">Angebot hinzufügen</button>
            </form>

            <table>
                <thead>
                    <tr>
                        <th>Angebotsnummer</th>
                        <th>Kundenname</th>
                        <th>Betrag netto</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {offers.map((offer) => (
                        <tr key={offer.id || offer.offer_number}>
                            <td>{offer.offer_number}</td>
                            <td>{offer.customer_name}</td>
                            <td>{offer.amount_net}</td>
                            <td>{offer.status}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Offers;
